import axios from 'axios'
import Configuration from './api/Configuration'
import CookiesStorageService from './CookiesStorageService'

const api = Configuration.Notification_Endpoints

// The backend caches one token per (source, user), so every module has its own
// record. A device has a single FCM token though, which means a token obtained
// here is the right one for all of them.
//
// That matters after the push switch is used: deleting the token invalidates it
// everywhere, but a plain re-enable would only refresh this module's record and
// leave the others pointing at a dead token - so Self Service, EDS and
// Recruitment notifications would silently stop until the user happened to open
// each of those modules. Registering the token under every source closes that
// window immediately.
export const SOURCES = ['UM', 'SELF', 'EDS', 'REC']

const putToken = async (token, source) => {
  await axios.put(`${Configuration.REACT_APP_BFF_BASE_URL}/${api.notificationsSendRegistrationToken}`, {
    notify_token: token,
    source,
    user_id: CookiesStorageService.getUserId(),
  })
}

/**
 * Registers an FCM token for the signed-in user under every module's source.
 *
 * Failures are logged rather than thrown: one source failing must not stop the
 * others, and the next launch registers again anyway.
 */
const registerNotificationToken = async (token) => {
  if (!token) return

  await Promise.all(SOURCES.map((source) => putToken(token, source).catch((error) => {
    // eslint-disable-next-line no-console
    console.error(`Failed to register notification token for ${source}`, error)
  })))
}

export default registerNotificationToken
